module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "idMainCloud",
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "width": "100%",
      "height": "100%",
      "border": "0px solid blue",
      "background-color": "#1c77ac",
      "background-image": "url(../static/aiphoto_images/bg_light.png)",
      "background-repeat": "no-repeat",
      "background-position": "center top",
      "overflow": "hidden"
    },
    attrs: {
      "id": "idMainCloud"
    }
  }, [_c('div', {
    ref: "cloud1",
    staticClass: "cloud",
    attrs: {
      "id": "cloud1"
    }
  }), _vm._v(" "), _c('div', {
    ref: "cloud2",
    staticClass: "cloud",
    attrs: {
      "id": "cloud2"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "0 0 auto",
      "border": "0px solid red",
      "width": "100%",
      "height": "80px",
      "display": "flex",
      "flex-direction": "row"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "1 1 auto",
      "border": "0px solid red",
      "width": "100%",
      "display": "flex",
      "flex-direction": "row",
      "background": "url(../static/aiphoto_images/bg_bg3.png) no-repeat center center",
      "z-index": "999"
    }
  }, [_c('div', {
    staticStyle: {
      "flex": "1 1 auto",
      "border": "0px solid blue",
      "height": "100%"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "0 0 auto",
      "border": "0px solid blue",
      "height": "100%",
      "width": "500px",
      "display": "flex",
      "flex-direction": "row",
      "align-items": "center",
      "justify-content": "center"
    }
  }, [_c('div', {
    ref: "idLoginFrm",
    staticStyle: {
      "display": "flex",
      "flex-direction": "row",
      "border": "1px solid var(--clrBG1)"
    },
    attrs: {
      "id": "idLoginFrm"
    }
  }, [_c('div', {
    staticStyle: {
      "flex": "0 0 auto",
      "border": "0px solid red",
      "width": "50px",
      "height": "100%"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "1 0 auto",
      "border": "0px solid red",
      "height": "100%",
      "flex-direction": "row"
    }
  }, [_c('div', {
    staticStyle: {
      "flex": "0 0 auto",
      "width": "100%",
      "height": "20px",
      "border": "0px solid blue"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "DIVNoSelect",
    staticStyle: {
      "flex": "0 0 auto",
      "width": "100%",
      "height": "30px",
      "border": "0px solid blue",
      "font-size": "24px",
      "text-align": "center"
    },
    style: ({
      'letter-spacing': _vm.ls1 + 'px'
    }),
    attrs: {
      "ctxt": "AIPHOTO管理平台"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "0 0 auto",
      "width": "100%",
      "height": "20px",
      "border": "0px solid blue"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "0 0 auto",
      "width": "90%",
      "height": "42px",
      "border": "0px solid blue",
      "display": "flex",
      "flex-direction": "row"
    }
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inpAcct),
      expression: "inpAcct"
    }],
    ref: "idLoginAcct",
    staticStyle: {
      "float": "left",
      "width": "100%",
      "height": "32px",
      "margin-top": "2px",
      "letter-spacing": "1px",
      "font-size": "20px"
    },
    attrs: {
      "id": "idLoginAcct",
      "type": "text",
      "maxlength": "16",
      "cpla": "账号"
    },
    domProps: {
      "value": (_vm.inpAcct)
    },
    on: {
      "keyup": _vm.onEnterPasd,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inpAcct = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "0 0 auto",
      "width": "100%",
      "height": "20px",
      "border": "0px solid blue"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "0 0 auto",
      "width": "90%",
      "height": "42px",
      "border": "0px solid blue",
      "display": "flex",
      "flex-direction": "row"
    }
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inpPswd),
      expression: "inpPswd"
    }],
    ref: "idLoginPasd",
    staticStyle: {
      "float": "left",
      "width": "100%",
      "height": "32px",
      "margin-top": "2px",
      "letter-spacing": "1px",
      "font-size": "20px"
    },
    attrs: {
      "id": "idLoginPasd",
      "type": "password",
      "maxlength": "16",
      "cpla": "密码"
    },
    domProps: {
      "value": (_vm.inpPswd)
    },
    on: {
      "keyup": _vm.onEnterLogin,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inpPswd = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "0 0 auto",
      "width": "100%",
      "height": "20px",
      "border": "0px solid blue"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "0 0 auto",
      "width": "90%",
      "height": "42px",
      "border": "0px solid blue",
      "display": "flex",
      "flex-direction": "row"
    }
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inpVcode),
      expression: "inpVcode"
    }],
    ref: "idVCode",
    staticStyle: {
      "float": "left",
      "width": "170px",
      "height": "32px",
      "margin-top": "2px",
      "letter-spacing": "1px",
      "font-size": "20px"
    },
    attrs: {
      "id": "idVCode",
      "type": "text",
      "maxlength": "5",
      "cpla": "验证码"
    },
    domProps: {
      "value": (_vm.inpVcode)
    },
    on: {
      "keyup": _vm.onEnterVcode,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inpVcode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('img', {
    ref: "idVCodeImg",
    staticStyle: {
      "width": "120px",
      "height": "40px",
      "border": "0px solid red",
      "margin-top": "0px",
      "margin-left": "20px"
    },
    attrs: {
      "id": "idVCodeImg",
      "src": ""
    },
    on: {
      "click": function($event) {
        return _vm.getVerifyCode()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "0 0 auto",
      "width": "100%",
      "height": "20px",
      "border": "0px solid blue"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "0 0 auto",
      "width": "90%",
      "height": "42px",
      "border": "0px solid blue",
      "display": "flex",
      "flex-direction": "row"
    }
  }, [_c('div', {
    staticStyle: {
      "flex": "0 0 auto",
      "width": "40px",
      "height": "40px",
      "border": "0px solid red"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "DIVBtn",
    staticStyle: {
      "flex": "1 0 auot",
      "width": "100%",
      "text-indent": "10px",
      "height": "42px",
      "line-height": "42px"
    },
    style: ({
      'letter-spacing': _vm.ls1 + 'px'
    }),
    attrs: {
      "ctxt": "确定"
    },
    on: {
      "click": _vm.onLoginClick
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "0 0 auto",
      "width": "100%",
      "height": "42px",
      "border": "0px solid blue"
    }
  }, [_c('cselect', {
    staticStyle: {
      "float": "right",
      "position": "relative",
      "margin-top": "20px",
      "height": "30px",
      "min-width": "150px",
      "z-index": "999"
    },
    attrs: {
      "onchange": _vm.onLangChange,
      "defv": _vm.cLan,
      "ctrl": _vm.ctrlLang,
      "csData": _vm.dataLang
    },
    model: {
      value: (_vm.cLan),
      callback: function($$v) {
        _vm.cLan = $$v
      },
      expression: "cLan"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "0 0 auto",
      "border": "0px solid red",
      "width": "50px",
      "height": "100%"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "1 1 auto",
      "border": "0px solid blue",
      "height": "100%"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "0 0 auto",
      "border": "0px solid red",
      "width": "100%",
      "height": "80px",
      "color": "#ffffff"
    }
  }, [_vm._m(3), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    ref: "idAppVer",
    staticStyle: {
      "text-align": "right",
      "border": "1px solid transparent",
      "width": "50%",
      "padding-right": "20px"
    },
    attrs: {
      "id": "idAppVer"
    }
  }, [_vm._v(_vm._s(_vm.AppVer))]), _c('td', {
    ref: "idSrvVer",
    staticStyle: {
      "border": "1px solid transparent",
      "width": "50%",
      "padding-left": "20px"
    },
    attrs: {
      "id": "idSrvVer"
    }
  }, [_vm._v(_vm._s(_vm.SerVer))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "flex": "0 0 auto",
      "width": "40px",
      "height": "40px",
      "border": "0px solid red"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "20px",
      "height": "20px",
      "margin-left": "10px",
      "margin-top": "10px",
      "background": "url(../static/images/name.png)",
      "background-size": "100% 100%"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "flex": "0 0 auto",
      "width": "40px",
      "height": "40px",
      "border": "0px solid red"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "20px",
      "height": "20px",
      "margin-left": "10px",
      "margin-top": "10px",
      "background": "url(../static/images/password.png)",
      "background-size": "100% 100%"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "flex": "0 0 auto",
      "width": "40px",
      "height": "40px",
      "border": "0px solid red"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "20px",
      "height": "20px",
      "margin-left": "10px",
      "margin-top": "10px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "color": "#ffffff",
      "text-align": "center",
      "font-size": "18px",
      "border": "1px solid transparent",
      "height": "45px"
    }
  }, [_c('pre')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f152ec92","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/login.vue
// module id = 799
// module chunks = 1